import { LanguageCode } from '../../core/i18n/languages';

export type CaseVerificationTextKey =
  | 'HumanVerification'
  | 'HumanVerificationBody'
  | 'VerificationFailed'
  | 'ZipCodeLabel'
  | 'ZipCodePlaceholder'
  | 'ZipCodeRequired'
  | 'Continue'
  | 'Home'
  | 'LogInWithBankID'
  | 'LanguagesMenuLink';

export const caseVerificationTranslations: Record<LanguageCode, Record<CaseVerificationTextKey, string>> = {
  no: {
    HumanVerification: 'Bekreft at det er deg',
    HumanVerificationBody: 'Fullfør verifiseringen under for å se status for sak {0}.',
    VerificationFailed: 'Verifisering mislyktes. Oppdater siden og prøv igjen.',
    ZipCodeLabel: 'Postnummer',
    ZipCodePlaceholder: 'Skriv inn postnummeret ditt',
    ZipCodeRequired: 'Vennligst skriv inn postnummeret ditt.',
    Continue: 'Fortsett',
    Home: 'Hjem',
    LogInWithBankID: 'Logg inn med BankID',
    LanguagesMenuLink: 'Språk',
  },
  se: {
    HumanVerification: 'Bekräfta att det är du',
    HumanVerificationBody: 'Slutför verifieringen nedan för att se status för ärende {0}.',
    VerificationFailed: 'Verifieringen misslyckades. Uppdatera sidan och försök igen.',
    ZipCodeLabel: 'Postnummer',
    ZipCodePlaceholder: 'Ange ditt postnummer',
    ZipCodeRequired: 'Ange ditt postnummer.',
    Continue: 'Fortsätt',
    Home: 'Hem',
    LogInWithBankID: 'Logga in med BankID',
    LanguagesMenuLink: 'Språk',
  },
  en: {
    HumanVerification: 'Verify it is you',
    HumanVerificationBody: 'Please complete the verification below to view case {0} status.',
    VerificationFailed: 'Verification failed. Please refresh the page and try again.',
    ZipCodeLabel: 'Postal code',
    ZipCodePlaceholder: 'Enter your postal code',
    ZipCodeRequired: 'Please enter your postal code.',
    Continue: 'Continue',
    Home: 'Home',
    LogInWithBankID: 'Log in with BankID',
    LanguagesMenuLink: 'Language',
  },
  dk: {
    HumanVerification: 'Bekræft, at det er dig',
    HumanVerificationBody: 'Gennemfør verificeringen nedenfor for at se status for sag {0}.',
    VerificationFailed: 'Verificering mislykkedes. Opdater siden og prøv igen.',
    ZipCodeLabel: 'Postnummer',
    ZipCodePlaceholder: 'Indtast dit postnummer',
    ZipCodeRequired: 'Indtast dit postnummer.',
    Continue: 'Fortsæt',
    Home: 'Hjem',
    LogInWithBankID: 'Log ind med BankID',
    LanguagesMenuLink: 'Sprog',
  },
  es: {
    HumanVerification: 'Verifique que es usted',
    HumanVerificationBody: 'Complete la verificación a continuación para ver el estado del caso {0}.',
    VerificationFailed: 'La verificación falló. Actualice la página e inténtelo de nuevo.',
    ZipCodeLabel: 'Código postal',
    ZipCodePlaceholder: 'Introduzca su código postal',
    ZipCodeRequired: 'Introduzca su código postal.',
    Continue: 'Continuar',
    Home: 'Inicio',
    LogInWithBankID: 'Iniciar sesión con BankID',
    LanguagesMenuLink: 'Idioma',
  },
  ar: {
    HumanVerification: 'تحقق من أنك أنت',
    HumanVerificationBody: 'أكمل التحقق أدناه لعرض حالة القضية {0}.',
    VerificationFailed: 'فشل التحقق. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
    ZipCodeLabel: 'الرمز البريدي',
    ZipCodePlaceholder: 'أدخل الرمز البريدي الخاص بك',
    ZipCodeRequired: 'يرجى إدخال الرمز البريدي الخاص بك.',
    Continue: 'متابعة',
    Home: 'الرئيسية',
    LogInWithBankID: 'تسجيل الدخول باستخدام BankID',
    LanguagesMenuLink: 'اللغة',
  },
};
